import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function userPreferenceRemove(params) {
    const { baseUrl, brandId, country, uberToken, clientId, preference, body } = params;

    invariant(baseUrl, 'baseUrl is a required param of userPreferenceRemove()');
    invariant(brandId, 'brandId is a required param of userPreferenceRemove()');
    invariant(country, 'country is a required param of userPreferenceRemove()');
    invariant(preference, 'preference is a required param of userPreferenceRemove()');
    invariant(body, 'body is a required param of userPreferenceRemove()');
    invariant(uberToken, 'uberToken is a required param of userPreferenceRemove()');
    invariant(clientId, 'clientId is a required param of userPreferenceRemove()');

    const headers = { 'Content-Type': 'application/json' };
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/person/@self/userpreferences/${preference}/values/${body.join(',')}`;

    return labelRequest(
        authenticatedRequest(new Request(url, { headers: new Headers(headers), method: 'DELETE' }), uberToken, clientId),
        'userPreferenceRemove',
    );
}
